<template>
  <div>
    <vs-alert
      v-if="$validator.errors.all().length > 0"
      color="danger"
      title="Atenção!!"
      active="true"
      class="my-3"
      style="height: auto !important"
    >
      <ul>
        <li
          class="mb-2"
          v-for="error in $validator.errors.all()"
          :key="error.id"
        >
          {{ error }}
        </li>
      </ul>
    </vs-alert>
    <form role="form" @submit.prevent="onSubmit">
      <vs-tabs alignment="fixed">
        <vs-tab label="Dados Gerais">
          <div class="vx-row mt-5 mb-5">
            <div class="vx-col sm:w-1/1 w-full mb-3">
              <vs-input
                size="large"
                class="w-full"
                label-placeholder="Hash"
                name="HASH"
                id="HASH"
                v-model="idExterno"
                v-validate="{ required: true, min: 6 }"
                val-icon-danger="clear"
                danger-text="Preencha este Campo"
                :readOnly="true"
              />
            </div>
          </div>
          <div class="vx-row mb-4 mt-3">
            <div class="vx-col sm:w-1/2 w-full mb-3">
              <label>Pessoa Física</label>
              <vs-switch
                v-model="pf"
                vs-value="PF"
                :disabled="!$can($actionsDefault.Escrita, subjectPermission)"
              ></vs-switch>
            </div>
            <div class="vx-col sm:w-1/2 w-full mb-3">
              <vs-input
                size="large"
                class="w-full"
                label-placeholder="Razao Social"
                name="Razao Social"
                id="Razao Social"
                v-model="formCadastro.razaoSocial"
                v-validate="{ required: true, min: 6 }"
                :state="validateState('Razao Social')"
                :danger="validateClass('Razao Social')"
                val-icon-danger="clear"
                danger-text="Preencha este Campo"
                :disabled="!$can($actionsDefault.Escrita, subjectPermission)"
              />
            </div>
          </div>
          <div class="vx-row mb-4">
            <div class="vx-col sm:w-1/3 w-full mb-2">
              <vs-input
                size="large"
                class="w-full"
                label-placeholder="Nome Fantasia"
                name="Nome Fantasia"
                id="Nome Fantasia"
                v-model="formCadastro.nome"
                v-validate="{ required: true, min: 6 }"
                :state="validateState('Nome Fantasia')"
                :danger="validateClass('Nome Fantasia')"
                val-icon-danger="clear"
                danger-text="Preencha este Campo"
                :disabled="!$can($actionsDefault.Escrita, subjectPermission)"
              />
            </div>
            <div class="vx-col sm:w-1/3 w-full mb-2">
              <vs-input
                size="large"
                class="w-full"
                :label-placeholder="placeHolderCpf"
                name="CPF / CNPJ"
                id="CPF"
                v-model="formCadastro.cnpj"
                v-validate="validateCpf"
                :state="validateState('CPF / CNPJ')"
                :danger="validateClass('CPF / CNPJ')"
                val-icon-danger="clear"
                danger-text="Preencha este Campo"
                v-mask="mascaraCpf"
                :disabled="!$can($actionsDefault.Escrita, subjectPermission)"
              />
            </div>
            <div class="vx-col sm:w-1/3 w-full mb-2">
              <vs-input
                size="large"
                class="w-full"
                label-placeholder="Data de Inicio de Operação"
                name="Data de Inicio de Operação"
                id="Data de Inicio de Operação"
                v-model="formCadastro.dataInicioOperacao"
                v-validate="{ required: true, date_format: 'dd/MM/yyyy' }"
                :state="validateState('Data de Inicio de Operação')"
                :danger="validateClass('Data de Inicio de Operação')"
                val-icon-danger="clear"
                v-mask="'##/##/####'"
                danger-text="Preencha este Campo"
                :disabled="!$can($actionsDefault.Escrita, subjectPermission)"
              />
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full mb-2">
              <vs-input
                size="large"
                class="w-full"
                label-placeholder="Email"
                name="Email"
                id="Email"
                v-model="formCadastro.email"
                v-validate="{ required: true, email: true }"
                :state="validateState('Email')"
                :danger="validateClass('Email')"
                val-icon-danger="clear"
                danger-text="Preencha este Campo"
                :disabled="!$can($actionsDefault.Escrita, subjectPermission)"
              />
            </div>
            <div class="vx-col sm:w-1/3 w-full mb-2">
              <vs-input
                size="large"
                class="w-full"
                label-placeholder="Central de Atendimento"
                name="Telefone"
                id="Telefone"
                v-model="formCadastro.telefone"
                v-validate="{ required: true }"
                :state="validateState('Telefone')"
                :danger="validateClass('Telefone')"
                val-icon-danger="clear"
                danger-text="Preencha este Campo"
                :disabled="!$can($actionsDefault.Escrita, subjectPermission)"
              />
            </div>
            <div class="vx-col sm:w-1/3 w-full mb-2">
              <vs-input
                size="large"
                class="w-full"
                label-placeholder="Telefone da Assistência"
                name="Telefone da Assistência"
                id="Telefone da Assistência"
                v-model="formCadastro.telefoneAssistencia"
                v-validate="{ required: true }"
                :state="validateState('Telefone da Assistência')"
                :danger="validateClass('Telefone da Assistência')"
                val-icon-danger="clear"
                danger-text="Preencha este Campo"
                :disabled="!$can($actionsDefault.Escrita, subjectPermission)"
              />
            </div>
          </div>

          <h5 class="mb-4">Dados certificado</h5>
          <div class="vx-col mb-4">
            <vs-tabs alignment="fixed">
              <vs-tab label="Apólice">
                <div class="vx-row flex flex-wrap py-5">
                  <div class="vx-col sm:w-1/3 w-full mb-5">
                    <vs-input
                      size="large"
                      class="w-full"
                      label-placeholder="Nome da Seguradora"
                      name="Nome da Seguradora"
                      id="Nome da Seguradora"
                      v-model="formCadastro.nomeSeguradoraApolice"
                      :state="validateState('Nome da Seguradora')"
                      :danger="validateClass('Nome da Seguradora')"
                      val-icon-danger="clear"
                      danger-text="Preencha este Campo"
                      :disabled="
                        !$can($actionsDefault.Escrita, subjectPermission)
                      "
                    />
                  </div>
                  <div class="vx-col sm:w-1/3 w-full mb-5">
                    <vs-input
                      size="large"
                      class="w-full"
                      label-placeholder="Cód SUSEP"
                      name="Cod SUSEP"
                      id="Cod SUSEP"
                      v-model="formCadastro.codSusep"
                      :state="validateState('Cod SUSEP')"
                      :danger="validateClass('Cod SUSEP')"
                      val-icon-danger="clear"
                      danger-text="Preencha este Campo"
                      :disabled="
                        !$can($actionsDefault.Escrita, subjectPermission)
                      "
                    />
                  </div>

                  <div class="vx-col sm:w-1/3 w-full mb-5">
                    <vs-input
                      size="large"
                      class="w-full"
                      label-placeholder="CNPJ"
                      name="CNPJ da Apolice"
                      id="CNPJ da Apolice"
                      v-model="formCadastro.cnpjApolice"
                      :state="validateState('CNPJ da Apolice')"
                      :danger="validateClass('CNPJ da Apolice')"
                      val-icon-danger="clear"
                      danger-text="Preencha este Campo"
                      v-mask="cpfCnpjMascara(formCadastro.cnpjApolice)"
                      :disabled="
                        !$can($actionsDefault.Escrita, subjectPermission)
                      "
                    />
                  </div>

                  <div class="vx-col sm:w-1/3 w-full mb-5">
                    <vs-input
                      size="large"
                      class="w-full"
                      label-placeholder="Telefone"
                      name="Telefone da Apolice"
                      id="Telefone da Apolice"
                      v-model="formCadastro.telefoneApolice"
                      :state="validateState('Telefone da Apolice')"
                      :danger="validateClass('Telefone da Apolice')"
                      val-icon-danger="clear"
                      danger-text="Preencha este Campo"
                      v-mask="'(##) ####-####'"
                      :disabled="
                        !$can($actionsDefault.Escrita, subjectPermission)
                      "
                    />
                  </div>

                  <div class="vx-col sm:w-1/3 w-full mb-5">
                    <vs-input
                      size="large"
                      class="w-full"
                      label-placeholder="Cep"
                      @input="buscaCep(cepApolice, 'apolice')"
                      name="Cep Apolice"
                      id="Cep Apolice"
                      v-model="cepApolice"
                      :state="validateState('Cep Apolice')"
                      :danger="validateClass('Cep Apolice')"
                      val-icon-danger="clear"
                      danger-text="Preencha este Campo"
                      v-mask="'##.###-###'"
                      :disabled="
                        !$can($actionsDefault.Escrita, subjectPermission)
                      "
                    />
                  </div>

                  <div class="vx-col sm:w-1/3 w-full mb-5">
                    <vs-input
                      size="large"
                      class="w-full"
                      label-placeholder="Endereço"
                      name="Endereço da Apolice"
                      id="Endereço da Apolice"
                      v-model="enderecoApolice"
                      :state="validateState('Endereço da Apolice')"
                      :danger="validateClass('Endereço da Apolice')"
                      val-icon-danger="clear"
                      danger-text="Preencha este Campo"
                      :disabled="
                        !$can($actionsDefault.Escrita, subjectPermission)
                      "
                    />
                  </div>
                  <div class="vx-col sm:w-1/6 w-full mb-5">
                    <vs-input
                      size="large"
                      class="w-full"
                      label-placeholder="Número"
                      name="Número da Apolice"
                      id="Número da Apolice"
                      v-model="numeroApolice"
                      :state="validateState('Número da Apolice')"
                      :danger="validateClass('Número da Apolice')"
                      val-icon-danger="clear"
                      danger-text="Preencha este Campo"
                      :disabled="
                        !$can($actionsDefault.Escrita, subjectPermission)
                      "
                    />
                  </div>
                  <div class="vx-col sm:w-1/6 w-full mb-5">
                    <vs-input
                      size="large"
                      class="w-full"
                      label-placeholder="Complemento"
                      name="Complemento da Apolice"
                      id="Complemento da Apolice"
                      v-model="complementoApolice"
                      :state="validateState('Complemento da Apolice')"
                      :danger="validateClass('Complemento da Apolice')"
                      val-icon-danger="clear"
                      danger-text="Preencha este Campo"
                      :disabled="
                        !$can($actionsDefault.Escrita, subjectPermission)
                      "
                    />
                  </div>

                  <div class="vx-col sm:w-1/3 w-full mb-5">
                    <vs-input
                      size="large"
                      class="w-full"
                      label-placeholder="Bairro"
                      name="Bairro Apolice"
                      id="Bairro Apolice"
                      v-model="bairroApolice"
                      :state="validateState('Bairro Apolice')"
                      :danger="validateClass('Bairro Apolice')"
                      val-icon-danger="clear"
                      danger-text="Preencha este Campo"
                      :disabled="
                        !$can($actionsDefault.Escrita, subjectPermission)
                      "
                    />
                  </div>
                  <div class="vx-col sm:w-1/3 w-full mb-5">
                    <vs-input
                      size="large"
                      class="w-full"
                      label-placeholder="Cidade"
                      name="Cidade Apolice"
                      id="Cidade Apolice"
                      v-model="cidadeApolice"
                      :state="validateState('Cidade Apolice')"
                      :danger="validateClass('Cidade Apolice')"
                      val-icon-danger="clear"
                      danger-text="Preencha este Campo"
                      :disabled="
                        !$can($actionsDefault.Escrita, subjectPermission)
                      "
                    />
                  </div>
                  <div class="vx-col sm:w-1/3 w-full mb-5">
                    <vs-input
                      size="large"
                      class="w-full"
                      label-placeholder="Estado"
                      name="Estado Apolice"
                      id="Estado Apolice"
                      v-model="estadoApolice"
                      :state="validateState('Estado Apolice')"
                      :danger="validateClass('Estado Apolice')"
                      val-icon-danger="clear"
                      danger-text="Preencha este Campo"
                      :disabled="
                        !$can($actionsDefault.Escrita, subjectPermission)
                      "
                    />
                  </div>
                </div>
              </vs-tab>
              <vs-tab label="Corretora">
                <div class="vx-row flex flex-wrap py-5">
                  <div class="vx-col sm:w-1/3 w-full mb-5">
                    <vs-input
                      size="large"
                      class="w-full"
                      label-placeholder="Corretora"
                      name="Corretora"
                      id="Corretora"
                      v-model="formCadastro.corretora"
                      :state="validateState('Corretora')"
                      :danger="validateClass('Corretora')"
                      val-icon-danger="clear"
                      danger-text="Preencha este Campo"
                      :disabled="
                        !$can($actionsDefault.Escrita, subjectPermission)
                      "
                    />
                  </div>

                  <div class="vx-col sm:w-1/3 w-full mb-5">
                    <vs-input
                      size="large"
                      class="w-full"
                      label-placeholder="CPF/CNPJ"
                      name="CNPJ da Corretora"
                      id="CNPJ da Corretora"
                      v-model="formCadastro.cnpjCorretora"
                      v-validate="{ required: false }"
                      :state="validateState('CNPJ da Corretora')"
                      :danger="validateClass('CNPJ da Corretora')"
                      val-icon-danger="clear"
                      danger-text="Preencha este Campo"
                      v-mask="cpfCnpjMascara(formCadastro.cnpjCorretora)"
                      :disabled="
                        !$can($actionsDefault.Escrita, subjectPermission)
                      "
                    />
                  </div>

                  <div class="vx-col sm:w-1/3 w-full mb-5">
                    <vs-input
                      size="large"
                      class="w-full"
                      label-placeholder="Cód SUSEP"
                      name="Cod SUSEP Corretora"
                      id="Cod SUSEP Corretora"
                      v-model="formCadastro.codSusepCorretora"
                      :state="validateState('Cod SUSEP Corretora')"
                      :danger="validateClass('Cod SUSEP Corretora')"
                      val-icon-danger="clear"
                      danger-text="Preencha este Campo"
                      :disabled="
                        !$can($actionsDefault.Escrita, subjectPermission)
                      "
                    />
                  </div>

                  <div class="vx-col sm:w-1/3 w-full mb-5">
                    <vs-input
                      size="large"
                      class="w-full"
                      label-placeholder="Telefone"
                      name="Telefone da Corretora"
                      id="Telefone da Corretora"
                      v-model="formCadastro.telefoneCorretora"
                      :state="validateState('Telefone da Corretora')"
                      :danger="validateClass('Telefone da Corretora')"
                      val-icon-danger="clear"
                      danger-text="Preencha este Campo"
                      v-mask="'(##) ####-####'"
                      :disabled="
                        !$can($actionsDefault.Escrita, subjectPermission)
                      "
                    />
                  </div>
                  <div class="vx-col sm:w-1/3 w-full mb-5">
                    <vs-input
                      size="large"
                      class="w-full"
                      label-placeholder="Email"
                      name="Email da Corretora"
                      id="Email da Corretora"
                      v-model="formCadastro.emailCorretora"
                      v-validate="{ email: true }"
                      :state="validateState('Email da Corretora')"
                      :danger="validateClass('Email da Corretora')"
                      val-icon-danger="clear"
                      danger-text="Digite um e-mail válido"
                      :disabled="
                        !$can($actionsDefault.Escrita, subjectPermission)
                      "
                    />
                  </div>

                  <div class="vx-col sm:w-1/3 w-full mb-5">
                    <vs-input
                      size="large"
                      class="w-full"
                      label-placeholder="Cep"
                      @input="buscaCep(cepCorretora, 'corretora')"
                      name="Cep Corretora"
                      id="Cep Corretora"
                      v-model="cepCorretora"
                      :state="validateState('Cep Corretora')"
                      :danger="validateClass('Cep Corretora')"
                      val-icon-danger="clear"
                      danger-text="Preencha este Campo"
                      v-mask="'##.###-###'"
                      :disabled="
                        !$can($actionsDefault.Escrita, subjectPermission)
                      "
                    />
                  </div>

                  <div class="vx-col sm:w-1/3 w-full mb-5">
                    <vs-input
                      size="large"
                      class="w-full"
                      label-placeholder="Endereço"
                      name="Endereço da Corretora"
                      id="Endereço da Corretora"
                      v-model="enderecoCorretora"
                      :state="validateState('Endereço da Corretora')"
                      :danger="validateClass('Endereço da Corretora')"
                      val-icon-danger="clear"
                      danger-text="Preencha este Campo"
                      :disabled="
                        !$can($actionsDefault.Escrita, subjectPermission)
                      "
                    />
                  </div>
                  <div class="vx-col sm:w-1/6 w-full mb-5">
                    <vs-input
                      size="large"
                      class="w-full"
                      label-placeholder="Número"
                      name="Número da Corretora"
                      id="Número da Corretora"
                      v-model="numeroCorretora"
                      :state="validateState('Número da Corretora')"
                      :danger="validateClass('Número da Corretora')"
                      val-icon-danger="clear"
                      danger-text="Preencha este Campo"
                      :disabled="
                        !$can($actionsDefault.Escrita, subjectPermission)
                      "
                    />
                  </div>
                  <div class="vx-col sm:w-1/6 w-full mb-5">
                    <vs-input
                      size="large"
                      class="w-full"
                      label-placeholder="Complemento"
                      name="Complemento da Corretora"
                      id="Complemento da Corretora"
                      v-model="complementoCorretora"
                      :state="validateState('Complemento da Corretora')"
                      :danger="validateClass('Complemento da Corretora')"
                      val-icon-danger="clear"
                      danger-text="Preencha este Campo"
                      :disabled="
                        !$can($actionsDefault.Escrita, subjectPermission)
                      "
                    />
                  </div>

                  <div class="vx-col sm:w-1/3 w-full mb-5">
                    <vs-input
                      size="large"
                      class="w-full"
                      label-placeholder="Bairro"
                      name="Bairro Corretora"
                      id="Bairro Corretora"
                      v-model="bairroCorretora"
                      :state="validateState('Bairro Corretora')"
                      :danger="validateClass('Bairro Corretora')"
                      val-icon-danger="clear"
                      danger-text="Preencha este Campo"
                      :disabled="
                        !$can($actionsDefault.Escrita, subjectPermission)
                      "
                    />
                  </div>
                  <div class="vx-col sm:w-1/3 w-full mb-5">
                    <vs-input
                      size="large"
                      class="w-full"
                      label-placeholder="Cidade"
                      name="Cidade Corretora"
                      id="Cidade Corretora"
                      v-model="cidadeCorretora"
                      :state="validateState('Cidade Corretora')"
                      :danger="validateClass('Cidade Corretora')"
                      val-icon-danger="clear"
                      danger-text="Preencha este Campo"
                      :disabled="
                        !$can($actionsDefault.Escrita, subjectPermission)
                      "
                    />
                  </div>
                  <div class="vx-col sm:w-1/3 w-full mb-5">
                    <vs-input
                      size="large"
                      class="w-full"
                      label-placeholder="Estado"
                      name="Estado Corretora"
                      id="Estado Corretora"
                      v-model="estadoCorretora"
                      :state="validateState('Estado Corretora')"
                      :danger="validateClass('Estado Corretora')"
                      val-icon-danger="clear"
                      danger-text="Preencha este Campo"
                      :disabled="
                        !$can($actionsDefault.Escrita, subjectPermission)
                      "
                    />
                  </div>
                </div>
              </vs-tab>
              <vs-tab label="Estipulante">
                <div class="vx-row flex flex-wrap py-5">
                  <div class="vx-col sm:w-1/3 w-full mb-2">
                    <vs-input
                      size="large"
                      class="w-full"
                      label-placeholder="Nome/Nome Social"
                      name="Nome Estipulante"
                      id="Nome Estipulante"
                      v-model="formCadastro.estipulante"
                      :state="validateState('Nome Estipulante')"
                      :danger="validateClass('Nome Estipulante')"
                      val-icon-danger="clear"
                      danger-text="Preencha este Campo"
                      :disabled="
                        !$can($actionsDefault.Escrita, subjectPermission)
                      "
                    />
                  </div>

                  <div class="vx-col sm:w-1/3 w-full mb-5">
                    <vs-input
                      size="large"
                      class="w-full"
                      label-placeholder="CPF/CNPJ"
                      name="CNPJ da Estipulante"
                      id="CNPJ da Estipulante"
                      v-model="formCadastro.cnpjEstipulante"
                      v-validate="{ required: false }"
                      :state="validateState('CNPJ da Estipulante')"
                      :danger="validateClass('CNPJ da Estipulante')"
                      val-icon-danger="clear"
                      danger-text="Preencha este Campo"
                      v-mask="cpfCnpjMascara(formCadastro.cnpjEstipulante)"
                      :disabled="
                        !$can($actionsDefault.Escrita, subjectPermission)
                      "
                    />
                  </div>

                  <div class="vx-col sm:w-1/3 w-full mb-2">
                    <vs-input
                      size="large"
                      class="w-full"
                      label-placeholder="Telefone"
                      name="Telefone da Estipulante"
                      id="Telefone da Estipulante"
                      v-model="formCadastro.telefoneEstipulante"
                      :state="validateState('Telefone da Estipulante')"
                      :danger="validateClass('Telefone da Estipulante')"
                      val-icon-danger="clear"
                      danger-text="Preencha este Campo"
                      v-mask="'(##) ####-####'"
                      :disabled="
                        !$can($actionsDefault.Escrita, subjectPermission)
                      "
                    />
                  </div>

                  <div class="vx-col sm:w-1/3 w-full mb-2">
                    <vs-input
                      size="large"
                      class="w-full"
                      label-placeholder="Cep"
                      @input="buscaCep(cepEstipulante, 'estipulante')"
                      name="Cep Estipulante"
                      id="Cep Estipulante"
                      v-model="cepEstipulante"
                      :state="validateState('Cep Estipulante')"
                      :danger="validateClass('Cep Estipulante')"
                      val-icon-danger="clear"
                      danger-text="Preencha este Campo"
                      v-mask="'##.###-###'"
                      :disabled="
                        !$can($actionsDefault.Escrita, subjectPermission)
                      "
                    />
                  </div>

                  <div class="vx-col sm:w-1/3 w-full mb-2">
                    <vs-input
                      size="large"
                      class="w-full"
                      label-placeholder="Endereço"
                      name="Endereço da Estipulante"
                      id="Endereço da Estipulante"
                      v-model="enderecoEstipulante"
                      :state="validateState('Endereço da Estipulante')"
                      :danger="validateClass('Endereço da Estipulante')"
                      val-icon-danger="clear"
                      danger-text="Preencha este Campo"
                      :disabled="
                        !$can($actionsDefault.Escrita, subjectPermission)
                      "
                    />
                  </div>
                  <div class="vx-col sm:w-1/6 w-full mb-2">
                    <vs-input
                      size="large"
                      class="w-full"
                      label-placeholder="Número"
                      name="Número da Estipulante"
                      id="Número da Estipulante"
                      v-model="numeroEstipulante"
                      :state="validateState('Número da Estipulante')"
                      :danger="validateClass('Número da Estipulante')"
                      val-icon-danger="clear"
                      danger-text="Preencha este Campo"
                      :disabled="
                        !$can($actionsDefault.Escrita, subjectPermission)
                      "
                    />
                  </div>
                  <div class="vx-col sm:w-1/6 w-full mb-2">
                    <vs-input
                      size="large"
                      class="w-full"
                      label-placeholder="Complemento"
                      name="Complemento da Estipulante"
                      id="Complemento da Estipulante"
                      v-model="complementoEstipulante"
                      :state="validateState('Complemento da Estipulante')"
                      :danger="validateClass('Complemento da Estipulante')"
                      val-icon-danger="clear"
                      danger-text="Preencha este Campo"
                      :disabled="
                        !$can($actionsDefault.Escrita, subjectPermission)
                      "
                    />
                  </div>

                  <div class="vx-col sm:w-1/3 w-full mb-2">
                    <vs-input
                      size="large"
                      class="w-full"
                      label-placeholder="Bairro"
                      name="Bairro Estipulante"
                      id="Bairro Estipulante"
                      v-model="bairroEstipulante"
                      :state="validateState('Bairro Estipulante')"
                      :danger="validateClass('Bairro Estipulante')"
                      val-icon-danger="clear"
                      danger-text="Preencha este Campo"
                      :disabled="
                        !$can($actionsDefault.Escrita, subjectPermission)
                      "
                    />
                  </div>
                  <div class="vx-col sm:w-1/3 w-full mb-2">
                    <vs-input
                      size="large"
                      class="w-full"
                      label-placeholder="Cidade"
                      name="Cidade Estipulante"
                      id="Cidade Estipulante"
                      v-model="cidadeEstipulante"
                      :state="validateState('Cidade Estipulante')"
                      :danger="validateClass('Cidade Estipulante')"
                      val-icon-danger="clear"
                      danger-text="Preencha este Campo"
                      :disabled="
                        !$can($actionsDefault.Escrita, subjectPermission)
                      "
                    />
                  </div>
                  <div class="vx-col sm:w-1/3 w-full mb-2">
                    <vs-input
                      size="large"
                      class="w-full"
                      label-placeholder="Estado"
                      name="Estado Estipulante"
                      id="Estado Estipulante"
                      v-model="estadoEstipulante"
                      :state="validateState('Estado Estipulante')"
                      :danger="validateClass('Estado Estipulante')"
                      val-icon-danger="clear"
                      danger-text="Preencha este Campo"
                      :disabled="
                        !$can($actionsDefault.Escrita, subjectPermission)
                      "
                    />
                  </div>
                </div>
              </vs-tab>
            </vs-tabs>
          </div>
        </vs-tab>
        <vs-tab label="Endereço"
          ><div class="vx-row mb-6">
            <div class="vx-col w-full">
              <span>CEP</span>
              <vs-input
                size="large"
                class="w-full"
                name="Cep"
                id="Cep"
                @input="buscaCep(formCadastro.cep, 'empresa')"
                v-model="formCadastro.cep"
                v-validate="{ required: true, min: 10 }"
                :state="validateState('Cep')"
                :danger="validateClass('Cep')"
                val-icon-danger="clear"
                danger-text="Preencha este Campo"
                v-mask="'##.###-###'"
                icon-pack="feather"
                icon="icon-home"
                icon-no-border
              />
            </div>
          </div>

          <div class="vx-row mb-6">
            <div class="vx-col w-full">
              <span>Endereço</span>
              <vs-input
                size="large"
                class="w-full"
                name="Endereço"
                id="Endereço"
                v-model="formCadastro.endereco"
                v-validate="{ required: true, min: 6 }"
                :state="validateState('Endereço')"
                :danger="validateClass('Endereço')"
                val-icon-danger="clear"
                danger-text="Preencha este Campo"
                icon-pack="feather"
                icon
                icon-no-border
              />
            </div>
          </div>

          <div class="vx-row mb-6">
            <div class="vx-col w-full">
              <span>Número</span>
              <vs-input
                size="large"
                class="w-full"
                name="Numero"
                id="Numero"
                v-model="formCadastro.numero"
                v-validate="{ required: true }"
                :state="validateState('Numero')"
                :danger="validateClass('Numero')"
                val-icon-danger="clear"
                danger-text="Preencha este Campo"
                icon-pack="feather"
                icon="icon-check-circle"
                icon-no-border
              />
            </div>
          </div>

          <div class="vx-row mb-6">
            <div class="vx-col w-full">
              <span>Complemento</span>
              <vs-input
                size="large"
                class="w-full"
                name="Complemento"
                id="Complemento"
                v-model="formCadastro.complemento"
                :state="validateState('Complemento')"
                :danger="validateClass('Complemento')"
                val-icon-danger="clear"
                danger-text="Preencha este Campo"
                icon-pack="feather"
                icon="icon-check-circle"
                icon-no-border
              />
            </div>
          </div>

          <div class="vx-row mb-6">
            <div class="vx-col w-full">
              <span>Bairro</span>
              <vs-input
                size="large"
                class="w-full"
                name="Bairro"
                id="Bairro"
                v-model="formCadastro.bairro"
                v-validate="{ required: true }"
                :state="validateState('Bairro')"
                :danger="validateClass('Bairro')"
                val-icon-danger="clear"
                danger-text="Preencha este Campo"
                icon-pack="feather"
                icon
                icon-no-border
              />
            </div>
          </div>

          <div class="vx-row mb-6">
            <div class="vx-col w-full">
              <span>Cidade</span>
              <vs-input
                size="large"
                class="w-full"
                name="Cidade"
                id="Cidade"
                v-model="formCadastro.cidade"
                v-validate="{ required: true }"
                :state="validateState('Cidade')"
                :danger="validateClass('Cidade')"
                val-icon-danger="clear"
                danger-text="Preencha este Campo"
                icon-pack="feather"
                icon
                icon-no-border
              />
            </div>
          </div>

          <div class="vx-row mb-6">
            <div class="vx-col w-full">
              <span>Estado</span>
              <vs-input
                size="large"
                class="w-full"
                name="Estado"
                id="Estado"
                v-model="formCadastro.estado"
                v-validate="{ required: true, min: 2, max: 2 }"
                :state="validateState('Estado')"
                :danger="validateClass('Estado')"
                val-icon-danger="clear"
                danger-text="Preencha este Campo"
                icon-pack="feather"
                icon
                icon-no-border
              />
            </div>
          </div>
        </vs-tab>
        <vs-tab label="Logo / Regulamento">
          <div class="vx-row img">
            <div
              class="vx-col containerimg sm:w-1/2 w-full mb-2 text-center mt-4"
            >
              <h4 class="mb-3">Logo</h4>
              <center>
                <img
                  :src="formCadastro.logo"
                  width="100%"
                  style="max-width: 250px"
                />
              </center>
              <input
                id="fileUpload"
                type="file"
                hidden
                v-on:change="selecionaEntidade($event, 'logo')"
              />
              <vs-button
                color="warning"
                type="border"
                class="mr-3 mt-2 text-center"
                @click.stop.prevent="chooseFiles('fileUpload')"
                v-if="$can('Logo', subjectPermission)"
              >
                Escolher uma Imagem
                <feather-icon icon="UploadIcon" class="ml-2" />
                <Br />
                <vs-chip v-if="objImagens.logo" class="mt-3">
                  <vs-avatar icon-pack="feather" icon="icon-file" />
                  <span>{{ objImagens.logo }}</span>
                </vs-chip>
              </vs-button>
            </div>

            <div
              class="vx-col containerimg sm:w-1/2 w-full mb-2 text-center mt-4"
            >
              <h4 class="mb-3">Regulamento</h4>
              <div
                style="text-align: center; max-width: 250px"
                v-if="formCadastro.regulamento"
              >
                <a :href="formCadastro.regulamento">Download</a>
              </div>
              <input
                id="fileUpload2"
                type="file"
                hidden
                v-on:change="selecionaEntidade($event, 'regulamento')"
              />

              <vs-button
                color="warning"
                type="border"
                class="mr-3 mt-2 text-center"
                @click.stop.prevent="chooseFiles('fileUpload2')"
                v-if="$can('Regulamento', subjectPermission)"
              >
                Escolher um Arquivo
                <feather-icon icon="UploadIcon" class="ml-2" />
                <Br />
                <vs-chip v-if="objImagens.regulamento" class="mt-3">
                  <vs-avatar icon-pack="feather" icon="icon-file" />
                  <span>{{ objImagens.regulamento }}</span>
                </vs-chip>
              </vs-button>
            </div>

            <div
              v-if="boletoComCapaEContracapa == 1"
              class="vx-col containerimg sm:w-1/2 w-full mb-2 text-center mt-4"
            >
              <h4 class="mb-3">Capa Boleto</h4>
              <center>
                <img
                  :src="formCadastro.capaBoleto"
                  width="100%"
                  style="max-width: 250px"
                />
              </center>
              <input
                id="fileUpload3"
                type="file"
                hidden
                v-on:change="selecionaEntidade($event, 'capaBoleto')"
              />
              <vs-button
                color="warning"
                type="border"
                class="mr-3 mt-2 text-center"
                @click.stop.prevent="chooseFiles('fileUpload3')"
                v-if="$can('Logo', subjectPermission)"
              >
                Escolher uma Imagem
                <feather-icon icon="UploadIcon" class="ml-2" />
                <Br />
                <vs-chip v-if="objImagens.capaBoleto" class="mt-3">
                  <vs-avatar icon-pack="feather" icon="icon-file" />
                  <span>{{ objImagens.capaBoleto }}</span>
                </vs-chip>
              </vs-button>
            </div>

            <div
              v-if="boletoComCapaEContracapa == 1"
              class="vx-col containerimg sm:w-1/2 w-full mb-2 text-center mt-4"
            >
              <h4 class="mb-3">Contracapa Boleto</h4>
              <center>
                <img
                  :src="formCadastro.contraCapaBoleto"
                  width="100%"
                  style="max-width: 250px"
                />
              </center>
              <input
                id="fileUpload4"
                type="file"
                hidden
                v-on:change="selecionaEntidade($event, 'contraCapaBoleto')"
              />
              <vs-button
                color="warning"
                type="border"
                class="mr-3 mt-2 text-center"
                @click.stop.prevent="chooseFiles('fileUpload4')"
                v-if="$can('Logo', subjectPermission)"
              >
                Escolher uma Imagem
                <feather-icon icon="UploadIcon" class="ml-2" />
                <Br />
                <vs-chip v-if="objImagens.contraCapaBoleto" class="mt-3">
                  <vs-avatar icon-pack="feather" icon="icon-file" />
                  <span>{{ objImagens.contraCapaBoleto }}</span>
                </vs-chip>
              </vs-button>
            </div>

            <div
              class="vx-col containerimg sm:w-1/2 w-full mb-2 text-center mt-4"
            >
              <h4 class="mb-3">Capa Proposta</h4>
              <center>
                <img
                  :src="formCadastro.capaProposta"
                  width="100%"
                  style="max-width: 250px"
                />
              </center>
              <input
                id="fileUpload5"
                type="file"
                hidden
                v-on:change="selecionaEntidade($event, 'capaProposta')"
              />
              <vs-button
                color="warning"
                type="border"
                class="mr-3 mt-2 text-center"
                @click.stop.prevent="chooseFiles('fileUpload5')"
                v-if="$can('Logo', subjectPermission)"
              >
                Escolher uma Imagem
                <feather-icon icon="UploadIcon" class="ml-2" />
                <Br />
                <vs-chip v-if="objImagens.capaProposta" class="mt-3">
                  <vs-avatar icon-pack="feather" icon="icon-file" />
                  <span>{{ objImagens.capaProposta }}</span>
                </vs-chip>
              </vs-button>
            </div>

            <div
              class="vx-col containerimg sm:w-1/2 w-full mb-2 text-center mt-4"
            >
              <h4 class="mb-3">Contracapa Proposta</h4>
              <center>
                <img
                  :src="formCadastro.contraCapaProposta"
                  width="100%"
                  style="max-width: 250px"
                />
              </center>
              <input
                id="fileUpload6"
                type="file"
                hidden
                v-on:change="selecionaEntidade($event, 'contraCapaProposta')"
              />
              <vs-button
                color="warning"
                type="border"
                class="mr-3 mt-2 text-center"
                @click.stop.prevent="chooseFiles('fileUpload6')"
                v-if="$can('Logo', subjectPermission)"
              >
                Escolher uma Imagem
                <feather-icon icon="UploadIcon" class="ml-2" />
                <Br />
                <vs-chip v-if="objImagens.contraCapaProposta" class="mt-3">
                  <vs-avatar icon-pack="feather" icon="icon-file" />
                  <span>{{ objImagens.contraCapaProposta }}</span>
                </vs-chip>
              </vs-button>
            </div>

            <div
              class="vx-col containerimg sm:w-1/2 w-full mb-2 text-center mt-4"
            >
              <h4 class="mb-3">Video Proposta</h4>
              <center>
                <img
                  :src="formCadastro.videoProposta"
                  width="100%"
                  style="max-width: 250px"
                />
              </center>
              <input
                id="fileUpload7"
                type="file"
                hidden
                v-on:change="selecionaEntidade($event, 'videoProposta')"
              />
              <vs-button
                color="warning"
                type="border"
                class="mr-3 mt-2 text-center"
                @click.stop.prevent="chooseFiles('fileUpload7')"
                v-if="$can('Logo', subjectPermission)"
              >
                Escolher um vídeo
                <feather-icon icon="UploadIcon" class="ml-2" />
                <Br />
                <vs-chip v-if="objImagens.videoProposta" class="mt-3">
                  <vs-avatar icon-pack="feather" icon="icon-file" />
                  <span>{{ objImagens.videoProposta }}</span>
                </vs-chip>
              </vs-button>
            </div>

            <div
              class="vx-col containerimg sm:w-1/2 w-full mb-2 text-center mt-4"
            >
              <h4 class="mb-3">Imagem de Loading da Vistoria</h4>
              <center>
                <img
                  :src="formCadastro.imgLoadingVistoria"
                  width="100%"
                  style="max-width: 250px"
                />
              </center>
              <input
                id="fileUpload8"
                type="file"
                hidden
                v-on:change="selecionaEntidade($event, 'imgLoadingVistoria')"
              />
              <vs-button
                color="warning"
                type="border"
                class="mr-3 mt-2 text-center"
                @click.stop.prevent="chooseFiles('fileUpload8')"
                v-if="$can('Logo', subjectPermission)"
              >
                Escolher um vídeo
                <feather-icon icon="UploadIcon" class="ml-2" />
                <Br />
                <vs-chip v-if="objImagens.imgLoadingVistoria" class="mt-3">
                  <vs-avatar icon-pack="feather" icon="icon-file" />
                  <span>{{ objImagens.imgLoadingVistoria }}</span>
                </vs-chip>
              </vs-button>
            </div>
          </div>
        </vs-tab>

        <vs-tab label="Configurações">
          <vs-col vs-justify="center" vs-align="center" vs-w="6">
            <div class="vx-row">
              <div class="vx-col mb-6">
                <label>Dias de Vencimento</label>
                <v-select
                  :options="diasVencimento"
                  name="Dias de Vencimento"
                  id="Dias de Vencimento"
                  multiple
                  v-model="formCadastro.diasVencimento"
                  v-validate="{ required: true }"
                  :state="validateState('Dias de Vencimento')"
                  :class="validateClass('Dias de Vencimento')"
                  :disabled="!$can($actionsDefault.Escrita, subjectPermission)"
                ></v-select>
              </div>
            </div>
            <div class="vx-row">
              <div class="vx-col mb-6">
                <span>Modo de exibição Dias de Vencimento.</span>
                <ul class="leftx">
                  <li>
                    <vs-radio
                      v-model="formCadastro.vencimentoMensalidadeTipo"
                      vs-name="typeCalendar"
                      vs-value="select"
                    >
                      Select (Padrão)</vs-radio
                    >
                  </li>
                  <li>
                    <vs-radio
                      v-model="formCadastro.vencimentoMensalidadeTipo"
                      vs-name="typeCalendar"
                      vs-value="calendar"
                      >Botões tipo Calendário
                    </vs-radio>
                  </li>
                </ul>
              </div>
            </div>

            <div class="vx-row">
              <div class="vx-col mb-6">
                <span>As Cobranças de valores a vista serão separadas?</span>
                <vs-switch
                  color="success"
                  v-model="formCadastro.cobrancaValoresAvistaApartados"
                  style="width: 60px"
                >
                  <span slot="on">Sim</span>
                  <span slot="off">Não</span>
                </vs-switch>
              </div>
            </div>
            <div class="vx-row">
              <div class="vx-col mb-6">
                <span>Permitir acesso as fotos da galeria na vistoria?</span>
                <vs-switch
                  color="success"
                  v-model="formCadastro.habilitarFotoGaleria"
                  style="width: 60px"
                >
                  <span slot="on">Sim</span>
                  <span slot="off">Não</span>
                </vs-switch>
              </div>
            </div>
            <div class="vx-row">
              <div class="vx-col mb-6">
                <span>Habilitar vistoria para veículo 0km?</span>
                <vs-switch
                  color="success"
                  v-model="formCadastro.solicitarTodasAsFotosVistoria"
                  style="width: 60px"
                >
                  <span slot="on">Sim</span>
                  <span slot="off">Não</span>
                </vs-switch>
              </div>
            </div>
            <div class="vx-row">
              <div class="vx-col mb-6">
                <span
                  >As Cobranças de valores a vista feitos Antes da
                  Vistoria?</span
                >
                <vs-switch
                  color="success"
                  v-model="formCadastro.cobrancaValoresAntesDaVistoria"
                  style="width: 90px"
                >
                  <span slot="on">Sim, Antes</span>
                  <span slot="off">Não, Depois</span>
                </vs-switch>
              </div>
            </div>
            <div class="vx-row">
              <div class="vx-col mb-6">
                <span>Quantidade de Dias para Vencimento à Vista</span>
                <vs-input
                  type="number"
                  size="large"
                  class="w-full"
                  name="Dias para Vencimento"
                  id="Dias para Vencimento"
                  v-model="formCadastro.qtdDiasVencimentoAvista"
                  v-validate="{ required: true }"
                  :state="validateState('Dias para Vencimento')"
                  :danger="validateClass('Dias para Vencimento')"
                  val-icon-danger="clear"
                  danger-text="Preencha este Campo"
                  icon-no-border
                />
              </div>
            </div>

            <div class="vx-row">
              <div class="vx-col mb-6">
                <span
                  >Quantidade de Dias Expiração das Propostas "Em Aberto"</span
                >
                <vs-input
                  type="number"
                  size="large"
                  class="w-full"
                  name="Dias Expiração"
                  id="Dias Expiração"
                  v-model="formCadastro.qtdDiasVencimentoPropostaEmAberto"
                  v-validate="{ required: true }"
                  :state="validateState('Dias Expiração')"
                  :danger="validateClass('Dias Expiração')"
                  val-icon-danger="clear"
                  danger-text="Preencha este Campo"
                  icon-no-border
                />
              </div>
            </div>
            <div class="vx-row">
              <div class="vx-col mb-6">
                <span>Propostas "Em Processo de Vistoria" também expiram?</span>
                <vs-switch
                  color="success"
                  v-model="processoVistoriaExpira"
                  style="width: 60px"
                >
                  <span slot="on">Sim</span>
                  <span slot="off">Não</span>
                </vs-switch>
              </div>
            </div>

            <div v-if="processoVistoriaExpira" class="vx-row">
              <div class="vx-col mb-6">
                <span>Em quantos dias?</span>
                <vs-input
                  type="number"
                  size="large"
                  class="w-full"
                  name="Dias Expiração Vistoria"
                  id="Dias Expiração Vistoria"
                  v-model="formCadastro.qtdDiasVencimentoPropostaEmVistoria"
                  v-validate="{ required: true }"
                  :state="validateState('Dias Expiração Vistoria')"
                  :danger="validateClass('Dias Expiração Vistoria')"
                  val-icon-danger="clear"
                  danger-text="Preencha este Campo"
                  icon-no-border
                />
              </div>
            </div>

            <div class="vx-row">
              <div class="vx-col mb-6">
                <span>Propostas "pendentes" também expiram?</span>
                <vs-switch
                  color="success"
                  v-model="processoPendenteExpira"
                  style="width: 60px"
                >
                  <span slot="on">Sim</span>
                  <span slot="off">Não</span>
                </vs-switch>
              </div>
            </div>

            <div v-if="processoPendenteExpira" class="vx-row">
              <div class="vx-col mb-6">
                <span>Em quantos dias?</span>
                <vs-input
                  type="number"
                  size="large"
                  class="w-full"
                  name="Dias Expiração Proposta Pendente"
                  id="Dias Expiração Proposta Pendente"
                  v-model="formCadastro.qtdDiasVencimentoPropostaPendente"
                  v-validate="{ required: true }"
                  :state="validateState('Dias Expiração Proposta Pendente')"
                  :danger="validateClass('Dias Expiração Proposta Pendente')"
                  val-icon-danger="clear"
                  danger-text="Preencha este Campo"
                  icon-no-border
                />
              </div>
            </div>

            <div class="vx-row">
              <div class="vx-col mb-6">
                <span>Permitir aprovação de propostas vencidas?</span>
                <vs-switch
                  color="success"
                  v-model="formCadastro.aprovarPropostasVencidas"
                  style="width: 60px"
                >
                  <span slot="on">Sim</span>
                  <span slot="off">Não</span>
                </vs-switch>
              </div>
            </div>
            <div class="vx-row">
              <div class="vx-col mb-6">
                <span>Permitir criar várias cotações por placa?</span>
                <vs-switch
                  color="success"
                  v-model="formCadastro.permiteVariasCotacoesPorPlaca"
                  style="width: 60px"
                >
                  <span slot="on">Sim</span>
                  <span slot="off">Não</span>
                </vs-switch>
              </div>
            </div>
            <div class="vx-row">
              <div class="vx-col mb-6">
                <span>Deseja trabalhar com restrições para veículos?</span>
                <vs-switch
                  color="success"
                  v-model="formCadastro.permitirRestricoes"
                  style="width: 60px"
                >
                  <span slot="on">Sim</span>
                  <span slot="off">Não</span>
                </vs-switch>
              </div>
            </div>

            <div class="vx-row">
              <div class="vx-col mb-6">
                <span>Permite alterar {{ $t('regional') }} na proposta?</span>
                <vs-switch
                  color="success"
                  v-model="formCadastro.permiteAlterarRegional"
                >
                  <span slot="on">Sim</span>
                  <span slot="off">Não</span>
                </vs-switch>
              </div>
            </div>
            <div class="vx-row">
              <div class="vx-col mb-6">
                <span
                  >Permitir o consultor alterar o grupo ao realizar a
                  cotação?</span
                >
                <vs-switch
                  color="success"
                  v-model="formCadastro.alterarGrupoVeiculoCotacao"
                  style="width: 60px"
                >
                  <span slot="on">Sim</span>
                  <span slot="off">Não</span>
                </vs-switch>
              </div>
            </div>

            <div class="vx-row">
              <div class="vx-col mb-6">
                <span>Exigir campo de Estacionamento na Proposta?</span>
                <vs-switch
                  color="success"
                  v-model="formCadastro.exigirCampoEstacionamentoProposta"
                  style="width: 60px"
                >
                  <span slot="on">Sim</span>
                  <span slot="off">Não</span>
                </vs-switch>
              </div>
            </div>

            <div class="vx-row">
              <div class="vx-col mb-6">
                <span
                  >Exibir a lista de Acessórios no passo da Vistoria no
                  App?</span
                >
                <vs-switch
                  color="success"
                  v-model="formCadastro.permitirAcessorios"
                  style="width: 60px"
                >
                  <span slot="on">Sim</span>
                  <span slot="off">Não</span>
                </vs-switch>
              </div>
            </div>
            <div class="vx-row">
              <div class="vx-col mb-6">
                <span>Exibir a validade na proposta?</span>
                <vs-switch
                  color="success"
                  v-model="formCadastro.exibeValidadeNaProposta"
                  style="width: 60px"
                >
                  <span slot="on">Sim</span>
                  <span slot="off">Não</span>
                </vs-switch>
              </div>
            </div>
            <div class="vx-row">
              <div class="vx-col mb-6">
                <span>Exibir capa e contracapa em Boleto?</span>
                <vs-switch
                  color="success"
                  v-model="formCadastro.boletoComCapaEContracapa"
                  style="width: 60px"
                >
                  <span slot="on">Sim</span>
                  <span slot="off">Não</span>
                </vs-switch>
              </div>
            </div>

            <div class="vx-row">
              <div class="vx-col mb-6">
                <span
                  >Motorcicletas sem estacionamento privado podem fazer
                  propostas?</span
                >
                <vs-switch
                  color="success"
                  v-model="formCadastro.liberaPropostaMotoNaRua"
                  style="width: 60px"
                >
                  <span slot="on">Sim</span>
                  <span slot="off">Não</span>
                </vs-switch>
              </div>
            </div>

            <div class="vx-row">
              <div class="vx-col mb-6">
                <span>Habilitar Classe</span>
                <vs-switch
                  color="success"
                  v-model="formCadastro.classe"
                  style="width: 60px"
                >
                  <span slot="on">Sim</span>
                  <span slot="off">Não</span>
                </vs-switch>
              </div>
            </div>

            <div class="vx-row">
              <div class="vx-col mb-6">
                <span>Moto pode gerar proposta?</span>
                <vs-switch
                  color="success"
                  v-model="formCadastro.geraPropostaMoto"
                  style="width: 60px"
                >
                  <span slot="on">Sim</span>
                  <span slot="off">Não</span>
                </vs-switch>
              </div>
            </div>

            <div
              class="vx-row"
              v-if="isBemProtegeCompany(formCadastro.idEmpresa)"
            >
              <div class="vx-col mb-6">
                <span>Aplica desconto para Grand Union?</span>
                <vs-switch
                  color="success"
                  v-model="formCadastro.aplicaContribuicao"
                  style="width: 60px"
                >
                  <span slot="on">Sim</span>
                  <span slot="off">Não</span>
                </vs-switch>
              </div>
            </div>

            <div class="vx-row">
              <div class="vx-col mb-6">
                <span
                  >Ao finalizar uma proposta, recusa automaticamente as outras
                  propostas não-finalizadas do mesmo veículo?</span
                >
                <vs-switch
                  color="success"
                  v-model="formCadastro.recusaPropostasConcorrentes"
                  style="width: 60px"
                >
                  <span slot="on">Sim</span>
                  <span slot="off">Não</span>
                </vs-switch>
              </div>
            </div>

            <div class="vx-row">
              <div class="vx-col mb-6">
                <span
                  >Travar a finalização de uma proposta caso não possua apólice
                  vinculada?</span
                >
                <vs-switch
                  color="success"
                  v-model="formCadastro.travaFinalizarPropostaSemApolice"
                  style="width: 60px"
                >
                  <span slot="on">Sim</span>
                  <span slot="off">Não</span>
                </vs-switch>
              </div>
            </div>

            <div class="vx-row">
              <div class="vx-col mb-6">
                <span>Aplica Regra de Comissionamento?</span>
                <vs-switch
                  color="success"
                  v-model="formCadastro.aplicarRegraComissionamento"
                  style="width: 60px"
                >
                  <span slot="on">Sim</span>
                  <span slot="off">Não</span>
                </vs-switch>
              </div>
            </div>

            <div class="vx-row">
              <div class="vx-col mb-6">
                <span>Máquina de status considera.</span>
                <ul class="leftx">
                  <li>
                    <vs-radio
                      v-model="formCadastro.usarDiaUtil"
                      vs-name="radios1"
                      vs-value="0"
                      >Dias corridos</vs-radio
                    >
                  </li>
                  <li>
                    <vs-radio
                      v-model="formCadastro.usarDiaUtil"
                      vs-name="radios1"
                      vs-value="1"
                      >Dias úteis</vs-radio
                    >
                  </li>
                </ul>
              </div>
            </div>

            <div class="vx-row">
              <div class="vx-col mb-6">
                <span
                  >Como calcular dias após data de saída da nota físcal de
                  veículos 0 km?
                </span>
                <ul class="leftx">
                  <li>
                    <vs-radio
                      v-model="formCadastro.calcularDiasUteisNfVistoria"
                      vs-name="radiosNf"
                      vs-value="corridos"
                      >Dias corridos</vs-radio
                    >
                  </li>
                  <li>
                    <vs-radio
                      v-model="formCadastro.calcularDiasUteisNfVistoria"
                      vs-name="radiosNf"
                      vs-value="uteis"
                      >Dias úteis</vs-radio
                    >
                  </li>
                </ul>
              </div>
            </div>

            <div class="vx-row">
              <div class="vx-col mb-6">
                <span
                  >Quantidade de Dias para ser considerado Zero KM<br />iniciando
                  no dia da Nota Fiscal.</span
                >
                <vs-input
                  type="number"
                  size="large"
                  class="w-full"
                  name="Dias Zero KM"
                  id="Dias para Zero KM"
                  v-model="formCadastro.diasZeroKM"
                  v-validate="{ required: true }"
                  :state="validateState('Dias para ser considirado zero KM')"
                  :danger="validateClass('Dias para ser considirado zero KM')"
                  val-icon-danger="clear"
                  danger-text="Preencha este Campo"
                  icon-no-border
                />
              </div>
            </div>

            <div class="vx-row">
              <div class="vx-col mb-6">
                <span>Renomear os tipos de veiculos ?</span>
                <vs-switch
                  color="success"
                  v-model="formCadastro.ativaMascarasVeiculos"
                  style="width: 60px"
                >
                  <span slot="on">Sim</span>
                  <span slot="off">Não</span>
                </vs-switch>
              </div>
            </div>
            <div class="vx-row">
              <div class="vx-col mb-6">
                <span>Unificar produtos de agregados adicionais?</span>
                <vs-switch
                  color="success"
                  v-model="formCadastro.unificarAgregados"
                  style="width: 60px"
                >
                  <span slot="on">Sim</span>
                  <span slot="off">Não</span>
                </vs-switch>
              </div>
            </div>

            <div class="vx-row">
              <div class="vx-col mb-6">
                <span>Aplicar regra de veiculos importados?</span>
                <vs-switch
                  color="success"
                  v-model="formCadastro.aplicarRegraVeiculoImportado"
                  style="width: 60px"
                >
                  <span slot="on">Sim</span>
                  <span slot="off">Não</span>
                </vs-switch>
              </div>
            </div>

            <div v-if="formCadastro.ativaMascarasVeiculos">
              <div class="vx-row">
                <div class="vx-col mb-6">
                  <span
                    >nome que será representado o tipo de veículo CARRO"</span
                  >
                  <vs-input
                    type="text"
                    size="large"
                    class="w-full"
                    name="Mascara Carro"
                    id="Mascara Carro"
                    v-model="formCadastro.mascaraCarro"
                    :state="validateState('Mascara Carro')"
                    :danger="validateClass('Mascara Carro')"
                    val-icon-danger="clear"
                    danger-text="Preencha este Campo"
                    icon-no-border
                  />
                </div>
              </div>
              <div class="vx-row">
                <div class="vx-col mb-6">
                  <span
                    >nome que será representado o tipo de veículo MOTO"</span
                  >
                  <vs-input
                    type="text"
                    size="large"
                    class="w-full"
                    name="Mascara MOTO"
                    id="Mascara MOTO"
                    v-model="formCadastro.mascaraMoto"
                    :state="validateState('Mascara MOTO')"
                    :danger="validateClass('Mascara MOTO')"
                    val-icon-danger="clear"
                    danger-text="Preencha este Campo"
                    icon-no-border
                  />
                </div>
              </div>
              <div class="vx-row">
                <div class="vx-col mb-6">
                  <span
                    >nome que será representado o tipo de veículo
                    CAMINHÃO"</span
                  >
                  <vs-input
                    type="text"
                    size="large"
                    class="w-full"
                    name="Mascara CAMINHÃO"
                    id="Mascara CAMINHÃO"
                    v-model="formCadastro.mascaraCaminhao"
                    :state="validateState('Mascara CAMINHÃO')"
                    :danger="validateClass('Mascara CAMINHÃO')"
                    val-icon-danger="clear"
                    danger-text="Preencha este Campo"
                    icon-no-border
                  />
                </div>
              </div>
              <div class="vx-row">
                <div class="vx-col mb-6">
                  <span
                    >nome que será representado o tipo de veículo
                    AGREGADO"</span
                  >
                  <vs-input
                    type="text"
                    size="large"
                    class="w-full"
                    name="Mascara AGREGADO"
                    id="Mascara AGREGADO"
                    v-model="formCadastro.mascaraAgregado"
                    :state="validateState('Mascara AGREGADO')"
                    mascaraImplemento
                    :danger="validateClass('Mascara AGREGADO')"
                    val-icon-danger="clear"
                    danger-text="Preencha este Campo"
                    icon-no-border
                  />
                </div>
              </div>
              <div class="vx-row">
                <div class="vx-col mb-6">
                  <span
                    >nome que será representado o tipo de veículo
                    IMPLEMENTO"</span
                  >
                  <vs-input
                    type="text"
                    size="large"
                    class="w-full"
                    name="Mascara IMPLEMENTO"
                    id="Mascara IMPLEMENTO"
                    v-model="formCadastro.mascaraImplemento"
                    :state="validateState('Mascara IMPLEMENTO')"
                    :danger="validateClass('Mascara IMPLEMENTO')"
                    val-icon-danger="clear"
                    danger-text="Preencha este Campo"
                    icon-no-border
                  />
                </div>
              </div>
            </div>
            <div class="vx-row">
              <div class="vx-col mb-6">
                <span>Aplicar regra de limite do valor do Acessório ?</span>
                <vs-switch
                  color="success"
                  v-model="formCadastro.aplicarRegraLimiteAcessorio"
                  style="width: 60px"
                >
                  <span slot="on">Sim</span>
                  <span slot="off">Não</span>
                </vs-switch>
              </div>
            </div>
            <div
              class="vx-row"
              v-if="this.formCadastro.aplicarRegraLimiteAcessorio"
            >
              <div class="vx-col mb-6">
                <span>Limite do valor do Acessório (%).</span>
                <vs-input
                  type="number"
                  size="large"
                  class="w-full"
                  name="Limite acessorio"
                  id="Limite valor acessorio"
                  v-model="formCadastro.limiteAcessorio"
                  :state="validateState('Limite valor acessorio')"
                  :danger="validateClass('Limite valor acessorio')"
                  val-icon-danger="clear"
                  danger-text="Preencha este Campo"
                  icon-no-border
                  :maxlength="2"
                  @input="onPercentageInput"
                  v-validate="{
                    required: this.formCadastro.aplicarRegraLimiteAcessorio,
                  }"
                />
              </div>
            </div>
          </vs-col>

          <vs-col vs-justify="center" vs-align="center" vs-w="6">
            <div class="vx-row">
              <div class="vx-col mb-6">
                <label for="botaoLogin">Cor Botão de Login</label>
                <div class="input-group-color">
                  <input
                    type="color"
                    size="large"
                    class="w-full color-picker"
                    name="botaoLogin"
                    id="botaoLogin"
                    v-on:change="changeThemeColor"
                    v-model="temaCor.botaoLogin"
                    v-validate="{ required: false }"
                    :state="validateState('botaoLogin')"
                    :danger="validateClass('botaoLogin')"
                    val-icon-danger="clear"
                    danger-text="Preencha este Campo"
                    icon-no-border
                  />
                  <vs-input
                    class="w-full"
                    name="botaoLogin"
                    id="botaoLogin"
                    :change="changeThemeColor"
                    v-model="temaCor.botaoLogin"
                    v-validate="{ required: false }"
                    :state="validateState('botaoLogin')"
                    :danger="validateClass('botaoLogin')"
                    val-icon-danger="clear"
                    danger-text="Preencha este Campo"
                    icon-no-border
                  />
                </div>
              </div>
            </div>
            <div class="vx-row">
              <div class="vx-col mb-6">
                <label for="alphaLogin">Cor Alpha Login</label>
                <div class="input-group-color">
                  <input
                    type="color"
                    size="large"
                    class="w-full color-picker"
                    name="alphaLogin"
                    id="alphaLogin"
                    v-on:change="changeThemeColor"
                    v-model="temaCor.alphaLogin"
                    v-validate="{ required: false }"
                    :state="validateState('alphaLogin')"
                    :danger="validateClass('alphaLogin')"
                    val-icon-danger="clear"
                    danger-text="Preencha este Campo"
                    icon-no-border
                  />
                  <vs-input
                    class="w-full"
                    name="alphaLogin"
                    id="alphaLogin"
                    v-on:change="changeThemeColor"
                    v-model="temaCor.alphaLogin"
                    v-validate="{ required: false }"
                    :state="validateState('alphaLogin')"
                    :danger="validateClass('alphaLogin')"
                    val-icon-danger="clear"
                    danger-text="Preencha este Campo"
                    icon-no-border
                  />
                </div>
              </div>
            </div>
            <div class="vx-row">
              <div class="vx-col mb-6">
                <label for="botaoFormularios"
                  >Cor do botões dos formulários</label
                >
                <div class="input-group-color">
                  <input
                    type="color"
                    size="large"
                    class="w-full color-picker"
                    name="botaoFormularios"
                    id="botaoFormularios"
                    v-on:change="changeThemeColor"
                    v-model="temaCor.botaoFormularios"
                    v-validate="{ required: false }"
                    :state="validateState('botaoFormularios')"
                    :danger="validateClass('botaoFormularios')"
                    val-icon-danger="clear"
                    danger-text="Preencha este Campo"
                    icon-no-border
                  />
                  <vs-input
                    class="w-full"
                    name="botaoFormularios"
                    id="botaoFormularios"
                    v-on:change="changeThemeColor"
                    v-model="temaCor.botaoFormularios"
                    v-validate="{ required: false }"
                    :state="validateState('botaoFormularios')"
                    :danger="validateClass('botaoFormularios')"
                    val-icon-danger="clear"
                    danger-text="Preencha este Campo"
                    icon-no-border
                  />
                </div>
              </div>
            </div>
            <div class="vx-row">
              <div class="vx-col mb-6">
                <label for="topoApp">Cor do topo do App</label>
                <div class="input-group-color">
                  <input
                    type="color"
                    size="large"
                    class="w-full color-picker"
                    name="topoApp"
                    id="topoApp"
                    v-on:change="changeThemeColor"
                    v-model="temaCor.topoApp"
                    v-validate="{ required: false }"
                    :state="validateState('topoApp')"
                    :danger="validateClass('topoApp')"
                    val-icon-danger="clear"
                    danger-text="Preencha este Campo"
                    icon-no-border
                  />
                  <vs-input
                    class="w-full"
                    name="topoApp"
                    id="topoApp"
                    v-on:change="changeThemeColor"
                    v-model="temaCor.topoApp"
                    v-validate="{ required: false }"
                    :state="validateState('topoApp')"
                    :danger="validateClass('topoApp')"
                    val-icon-danger="clear"
                    danger-text="Preencha este Campo"
                    icon-no-border
                  />
                </div>
              </div>
            </div>
            <div class="vx-row">
              <div class="vx-col mb-6">
                <label for="bottomBar">Cor da barra inferior do App</label>
                <div class="input-group-color">
                  <input
                    type="color"
                    size="large"
                    class="w-full color-picker"
                    name="bottomBar"
                    id="bottomBar"
                    v-on:change="changeThemeColor"
                    v-model="temaCor.bottomBar"
                    v-validate="{ required: false }"
                    :state="validateState('bottomBar')"
                    :danger="validateClass('bottomBar')"
                    val-icon-danger="clear"
                    danger-text="Preencha este Campo"
                    icon-no-border
                  />
                  <vs-input
                    class="w-full"
                    name="bottomBar"
                    id="bottomBar"
                    v-on:change="changeThemeColor"
                    v-model="temaCor.bottomBar"
                    v-validate="{ required: false }"
                    :state="validateState('bottomBar')"
                    :danger="validateClass('bottomBar')"
                    val-icon-danger="clear"
                    danger-text="Preencha este Campo"
                    icon-no-border
                  />
                </div>
              </div>
            </div>
            <div class="vx-row">
              <div class="vx-col mb-6">
                <label for="botaoBottomBar"
                  >Cor do Botão da barrra inferior</label
                >
                <div class="input-group-color">
                  <input
                    type="color"
                    size="large"
                    class="w-full color-picker"
                    name="botaoBottomBar"
                    id="botaoBottomBar"
                    v-on:change="changeThemeColor"
                    v-model="temaCor.botaoBottomBar"
                    v-validate="{ required: false }"
                    :state="validateState('botaoBottomBar')"
                    :danger="validateClass('botaoBottomBar')"
                    val-icon-danger="clear"
                    danger-text="Preencha este Campo"
                    icon-no-border
                  />
                  <vs-input
                    class="w-full"
                    name="botaoBottomBar"
                    id="botaoBottomBar"
                    v-on:change="changeThemeColor"
                    v-model="temaCor.botaoBottomBar"
                    v-validate="{ required: false }"
                    :state="validateState('botaoBottomBar')"
                    :danger="validateClass('botaoBottomBar')"
                    val-icon-danger="clear"
                    danger-text="Preencha este Campo"
                    icon-no-border
                  />
                </div>
              </div>
            </div>
            <div class="vx-row">
              <div class="vx-col mb-6">
                <label for="botaoPrimario">Cor dos botões primarios</label>
                <div class="input-group-color">
                  <input
                    type="color"
                    size="large"
                    class="w-full color-picker"
                    name="botaoPrimario"
                    id="botaoPrimario"
                    v-on:change="changeThemeColor"
                    v-model="temaCor.botaoPrimario"
                    v-validate="{ required: false }"
                    :state="validateState('botaoPrimario')"
                    :danger="validateClass('botaoPrimario')"
                    val-icon-danger="clear"
                    danger-text="Preencha este Campo"
                    icon-no-border
                  />
                  <vs-input
                    class="w-full"
                    name="botaoPrimario"
                    id="botaoPrimario"
                    v-on:change="changeThemeColor"
                    v-model="temaCor.botaoPrimario"
                    v-validate="{ required: false }"
                    :state="validateState('botaoPrimario')"
                    :danger="validateClass('botaoPrimario')"
                    val-icon-danger="clear"
                    danger-text="Preencha este Campo"
                    icon-no-border
                  />
                </div>
              </div>
            </div>
            <div class="vx-row">
              <div class="vx-col mb-6">
                <label for="tituloPrimario">Cor do titulo Primario</label>
                <div class="input-group-color">
                  <input
                    type="color"
                    size="large"
                    class="w-full color-picker"
                    name="tituloPrimario"
                    id="tituloPrimario"
                    v-on:change="changeThemeColor"
                    v-model="temaCor.tituloPrimario"
                    v-validate="{ required: false }"
                    :state="validateState('tituloPrimario')"
                    :danger="validateClass('tituloPrimario')"
                    val-icon-danger="clear"
                    danger-text="Preencha este Campo"
                    icon-no-border
                  />
                  <vs-input
                    class="w-full"
                    name="tituloPrimario"
                    id="tituloPrimario"
                    v-on:change="changeThemeColor"
                    v-model="temaCor.tituloPrimario"
                    v-validate="{ required: false }"
                    :state="validateState('tituloPrimario')"
                    :danger="validateClass('tituloPrimario')"
                    val-icon-danger="clear"
                    danger-text="Preencha este Campo"
                    icon-no-border
                  />
                </div>
              </div>
            </div>
          </vs-col>
        </vs-tab>
      </vs-tabs>

      <div class="vx-row">
        <div class="vx-col w-full text-right mt-5">
          <vs-button
            color="warning"
            type="border"
            class="mr-3 mb-2"
            @click.stop.prevent="onReset"
            >Cancelar</vs-button
          >

          <BotaoSubmit
            variant="success"
            :edit="true"
            :aguarde="aguardeCadastro"
            reference="BtnEditar"
            v-if="$can($actionsDefault.Escrita, subjectPermission)"
          ></BotaoSubmit>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import locale from './../../locale';
import * as lang from 'vuejs-datepicker/src/locale';
import service from '../../services';
import cpfCnpj from '../../services/cpfCnpj';
import BotaoSubmit from './../../components/BotaoSubmit';
import jwt from 'jsonwebtoken';
import { decryptData } from '../../services/decryptData';

import vSelect from 'vue-select';

import functions from '../../utils/functions';

export default {
  props: ['subjectPermission'],
  watch: {
    selectedPessoa: function (newValue) {
      if (newValue == 'PF') {
        this.mascaraCpf = '###.###.###-##';
        this.validateCpf = { required: true, length: 14 };
        this.placeHolderNome = 'Nome';
        this.placeHolderCpf = 'CPF';
      } else {
        this.mascaraCpf = '##.###.###/####-##';
        this.validateCpf = { required: true, length: 18 };
        this.placeHolderNome = 'Razão Social';
        this.placeHolderCpf = 'CNPJ';
      }
    },
    pf: function (newValue) {
      if (newValue == true) {
        this.pj = false;
        this.selectedPessoa = 'PF';
      } else {
        this.pj = true;
        this.selectedPessoa = 'PJ';
      }
    },
  },
  data() {
    return {
      aguardeCadastro: false,
      pf: false,
      pj: false,
      fotoAtual: 0,
      currentPage: 1,
      pageCount: 0,
      hasImage: false,
      files: new FormData(),
      image: null,
      selectedPessoa: 'PJ',
      mascaraCpf: '##.###.###/####-##',
      validateCpf: { required: true, length: 18 },
      placeHolderCpf: 'CNPJ',
      placeHolderNome: 'Razão Social',
      languages: lang,
      objImagens: {},
      boletoComCapaEContracapa: null,
      funcoesValicao: null,
      diasVencimento: [
        1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20,
        21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31,
      ],
      temaCor: {},
      idExterno: null,
      formCadastro: {
        idEmpresa: null,
        nome: '',
        email: '',
        cnpj: '',
        telefone: '',
        telefoneAssistencia: '',
        logo: '',
        regulamento: '',
        diasVencimento: [],
        cep: '',
        endereco: '',
        numero: '',
        complemento: '',
        bairro: '',
        cidade: '',
        estado: '',
        pais: 'Brasil',
        razaoSocial: '',
        capaBoleto: null,
        contraCapaBoleto: null,
        cobrancaValoresAvistaApartados: false,
        habilitarFotoGaleria: null,
        solicitarTodasAsFotosVistoria: null,
        cobrancaValoresAntesDaVistoria: false,
        qtdDiasVencimentoAvista: '',
        qtdDiasNaoPagamento: '',
        dataInicioOperacao: null,
        temaCor: {},
        aprovarPropostasVencidas: null,
        permiteVariasCotacoesPorPlaca: null,
        permitirRestricoes: null,
        permiteAlterarRegional: null,
        alterarGrupoVeiculoCotacao: true,
        exigirCampoEstacionamentoProposta: null,
        permitirAcessorios: null,
        qtdDiasVencimentoPropostaEmAberto: null,
        exibeValidadeNaProposta: null,
        boletoComCapaEContracapa: null,
        usarDiaUtil: null,
        qtdDiasVencimentoPropostaEmVistoria: null,
        qtdDiasVencimentoPropostaPendente: null,
        aplicaContribuicao: false,
        liberaPropostaMotoNaRua: true,
        vencimentoMensalidadeTipo: null,
        subTipoVeiculos: null,
        capaProposta: null,
        contraCapaProposta: null,
        videoProposta: null,
        imgLoadingVistoria: null,
        recusaPropostasConcorrentes: null,
        classe: false,
        corretora: null,
        codSusep: null,
        codSusepCorretora: null,
        cnpjCorretora: null,
        estipulante: null,
        cnpjEstipulante: null,
        diasZeroKM: null,
        calcularDiasUteisNfVistoria: null,
        travaFinalizarPropostaSemApolice: null,
        ativaMascarasVeiculos: null,
        mascaraCarro: null,
        mascaraMoto: null,
        mascaraCaminhao: null,
        mascaraAgregado: null,
        mascaraImplemento: null,
        aplicarRegraComissionamento: null,
        geraPropostaMoto: null,
        enderecoCorretora: '',
        telefoneCorretora: '',
        emailCorretora: '',
        nomeSeguradoraApolice: '',
        cnpjApolice: '',
        enderecoApolice: '',
        telefoneApolice: '',
        enderecoEstipulante: '',
        telefoneEstipulante: '',
        unificarAgregados: false,
        aplicarRegraVeiculoImportado: false,
        aplicarRegraLimiteAcessorio: false,
        limiteAcessorio: null,
      },
      processoVistoriaExpira: null,
      processoPendenteExpira: null,
      cepCorretora: '',
      enderecoCorretora: '',
      numeroCorretora: '',
      complementoCorretora: '',
      bairroCorretora: '',
      cidadeCorretora: '',
      estadoCorretora: '',
      cepApolice: '',
      enderecoApolice: '',
      numeroApolice: '',
      complementoApolice: '',
      bairroApolice: '',
      cidadeApolice: '',
      estadoApolice: '',
      cepEstipulante: '',
      enderecoEstipulante: '',
      numeroEstipulante: '',
      complementoEstipulante: '',
      bairroEstipulante: '',
      cidadeEstipulante: '',
      estadoEstipulante: '',
    };
  },
  methods: {
    selecionaEntidade(event, alvo) {
      var files = event.target.files || event.dataTransfer.files;
      if (!files.length) return;
      this.files.set('file', event.target.files[0], event.target.files[0].name);
      this.objImagens[alvo] = event.target.files[0].name;
      this.$vs.loading();
      service
        .upload(
          'Upload',
          [alvo] + '/' + this.formCadastro.idEmpresa,
          this.files,
        )
        .then((response) => {
          this.formCadastro[alvo] = response;
          this.$vs.loading.close();
        })
        .catch(function (e) {
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: e,
            color: 'danger',
          });
          this.$vs.loading.close();
        });
    },

    successUpload() {
      this.$vs.notify({
        color: 'success',
        title: 'Upload Success',
        text: 'Lorem ipsum dolor sit amet, consectetur',
      });
    },
    chooseFiles(id) {
      document.getElementById(id).click();
    },
    validateState(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.veeErrors.has(ref);
      }
      return null;
    },
    validateClass(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return this.veeErrors.has(ref);
      }
      return null;
    },
    buscaDadosCadastro() {
      if (localStorage.getItem('user-token')) {
        try {
          this.$vs.loading();
          const decoded = jwt.decode(localStorage.getItem('user-token'));
          this.formCadastro.idEmpresa = decoded.id_empresa;

          service
            .getAll(
              'g',
              {},
              'empresas/list/idEmpresa/' + this.formCadastro.idEmpresa,
            )
            .then((res) => {
              res.data = decryptData(res.data);
              const [Empresa] = res.data;
              this.temaCor = JSON.parse(Empresa.temaCor);
              this.idExterno = Empresa.idExterno;
              this.boletoComCapaEContracapa = Empresa.boletoComCapaEContracapa;
              this.formCadastro.classe = Empresa.classe
                ? Empresa.classe
                : false;

              if (Empresa.qtdDiasVencimentoPropostaEmVistoria) {
                this.processoVistoriaExpira = true;
              }

              if (Empresa.qtdDiasVencimentoPropostaPendente) {
                this.processoPendenteExpira = true;
              }

              Object.keys(this.formCadastro).forEach((element) => {
                if (element == 'diasVencimento') {
                  this.formCadastro.diasVencimento =
                    res.data[0][element].split(',');
                } else this.formCadastro[element] = res.data[0][element];

                if (element == 'cnpj' || element == 'cpf') {
                  if (res.data[0][element].length > 14) {
                    this.pj = true;
                  } else {
                    this.pf = true;
                  }
                }
              });
              this.separaEnderecoCorretora();
              this.separaEnderecoApolice();
              this.separaEnderecoEstipulante();
              this.$vs.loading.close();
            })
            .catch((e) => {
              this.$vs.notify({
                position: 'top-center',
                title: 'Atenção',
                text: e,
                color: 'danger',
              });
              this.$vs.loading.close();
            });
        } catch (error) {
          throw new Error(error);
        }
      }
    },
    startImageResize() {
      this.carregando = true;
    },
    endImageResize() {
      this.carregando = false;
    },
    async buscaCep(value, referencia) {
      const ehCorretora = referencia === 'corretora';
      const ehApolice = referencia === 'apolice';
      const ehEstipulante = referencia === 'estipulante';

      if (value && value.length === 10) {
        try {
          this.$vs.loading();
          const cep = value.replace('.', '').replace('-', '');
          const { data } = await service.post('g', 'BuscaCEP', {
            cep,
          });
          const adress = decryptData(data);
          if (ehCorretora) {
            this.enderecoCorretora = adress.street;
            this.bairroCorretora = adress.neighborhood;
            this.cidadeCorretora = adress.city;
            this.estadoCorretora = adress.state;
            return;
          }
          if (ehApolice) {
            this.enderecoApolice = adress.street;
            this.bairroApolice = adress.neighborhood;
            this.cidadeApolice = adress.city;
            this.estadoApolice = adress.state;
            return;
          }
          if (ehEstipulante) {
            this.enderecoEstipulante = adress.street;
            this.bairroEstipulante = adress.neighborhood;
            this.cidadeEstipulante = adress.city;
            this.estadoEstipulante = adress.state;
            return;
          }
          this.formCadastro.endereco = adress.street;
          this.formCadastro.bairro = adress.neighborhood;
          this.formCadastro.cidade = adress.city;
          this.formCadastro.estado = adress.state;
        } catch {
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: 'Não Foi possível encontrar o cep',
            color: 'danger',
          });
        } finally {
          this.$vs.loading.close();
        }
      }
    },
    setImage: function (output) {
      this.necessitaUpload = true;
      this.hasImage = true;
      this.image = output;
      this.imgUrl = output.dataUrl;
      this.styleFoto = 'display:none';
    },
    onSubmit() {
      if (cpfCnpj.valida_cpf_cnpj(this.formCadastro.cnpj) == false) {
        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: `Este ${this.placeHolderCpf} não é válido`,
          color: 'danger',
        });
        return;
      }

      this.$validator.validateAll().then((result) => {
        if (result) {
          this.aguardeCadastro = true;

          this.formCadastro.usarDiaUtil =
            this.formCadastro.usarDiaUtil == '1' ? true : false;

          if (!this.processoVistoriaExpira) {
            this.formCadastro.qtdDiasVencimentoPropostaEmVistoria = null;
          }

          if (
            !this.formCadastro.aplicarRegraLimiteAcessorio &&
            this.formCadastro.limiteAcessorio
          ) {
            this.formCadastro.limiteAcessorio = null;
          }

          if (!this.processoPendenteExpira) {
            this.formCadastro.qtdDiasVencimentoPropostaPendente = null;
          }
          this.formataEnderecoCorretora();
          this.formataEnderecoApolice();
          this.formataEnderecoEstipulante();
          service
            .put('Empresa', 'Atualizar', this.formCadastro)
            .then(() => {
              this.aguardeCadastro = false;
              this.$vs.notify({
                position: 'top-center',
                title: 'Atenção',
                text: 'Dados Atualizados com sucesso',
                color: 'success',
              });
            })
            .catch(() => {
              this.aguardeCadastro = false;
              this.$vs.notify({
                position: 'top-center',
                title: 'Atenção',
                text: 'Não foi possível atualizar os Dados',
                color: 'danger',
              });
            });

          return;
        }

        this.aguardeCadastro = false;
        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: 'Não foi possível atualizar os Dados',
          color: 'danger',
        });

        return;
      });
    },
    onReset(evt) {
      evt.preventDefault();
      this.formCadastro = {
        nome: '',
        email: '',
        cnpj: '',
        telefone: '',
        telefoneAssistencia: '',
        logo: '',
        regulamento: '',
        cep: '',
        endereco: '',
        numero: '',
        complemento: '',
        bairro: '',
        cidade: '',
        estado: '',
        emailCorretora: '',
        telefoneCorretora: '',
        enderecoCorretora: '',
        codSusep: '',
        codSusepCorretora: '',
        telefoneApolice: '',
        enderecoApolice: '',
        nomeSeguradoraApolice: '',
        cnpjApolice: '',
        telefoneEstipulante: '',
        enderecoEstipulante: '',
        pais: 'Brasil',
        razaoSocial: '',
        cobrancaValoresAvistaApartados: false,
        habilitarFotoGaleria: null,
        solicitarTodasAsFotosVistoria: null,
        cobrancaValoresAntesDaVistoria: false,
        qtdDiasVencimentoAvista: '',
        qtdDiasNaoPagamento: '',
        dataInicioOperacao: null,
        capaBoleto: null,
        contraCapaBoleto: null,
        aprovarPropostasVencidas: null,
        permiteVariasCotacoesPorPlaca: null,
        permitirRestricoes: 1,
        permiteAlterarRegional: null,
        alterarGrupoVeiculoCotacao: true,
        exigirCampoEstacionamentoProposta: null,
        permitirAcessorios: null,
        qtdDiasVencimentoPropostaEmAberto: null,
        exibeValidadeNaProposta: null,
        usarDiaUtil: null,
        qtdDiasVencimentoPropostaEmVistoria: null,
        qtdDiasVencimentoPropostaPendente: null,
        limiteFotosAdicionaisVistoria: 5,
        liberaPropostaMotoNaRua: true,
        vencimentoMensalidadeTipo: null,
        capaProposta: null,
        contraCapaProposta: null,
        videoProposta: null,
        imgLoadingVistoria: null,
        calcularDiasUteisNfVistoria: null,
      };
      this.$nextTick(() => {
        this.show = true;
      });
    },
    changeThemeColor(event) {
      const { value, name } = event.target;
      const objTemaCor = JSON.parse(this.formCadastro.temaCor);

      objTemaCor[name] = value;
      this.formCadastro.temaCor = JSON.stringify(objTemaCor);
    },
    isBemProtegeCompany(idEmpresa) {
      return functions.verificaEmpresaBemProtege(idEmpresa);
    },
    formataEnderecoCorretora() {
      const dados = [
        this.enderecoCorretora,
        this.numeroCorretora,
        this.complementoCorretora,
        this.bairroCorretora,
        this.cepCorretora,
        this.cidadeCorretora,
        this.estadoCorretora,
      ];
      this.formCadastro.enderecoCorretora = dados.join(' - ');
    },
    separaEnderecoCorretora() {
      if (this.formCadastro.enderecoCorretora) {
        const [endereco, numero, complemento, bairro, cep, cidade, estado] =
          this.formCadastro.enderecoCorretora.split(' - ');

        this.enderecoCorretora = endereco;
        this.numeroCorretora = numero;
        this.complementoCorretora = complemento;
        this.bairroCorretora = bairro;
        this.cepCorretora = cep;
        this.cidadeCorretora = cidade;
        this.estadoCorretora = estado;
      }
      return;
    },
    formataEnderecoApolice() {
      const dados = [
        this.enderecoApolice,
        this.numeroApolice,
        this.complementoApolice,
        this.bairroApolice,
        this.cepApolice,
        this.cidadeApolice,
        this.estadoApolice,
      ];
      this.formCadastro.enderecoApolice = dados.join(' - ');
    },
    separaEnderecoApolice() {
      if (this.formCadastro.enderecoApolice) {
        const [endereco, numero, complemento, bairro, cep, cidade, estado] =
          this.formCadastro.enderecoApolice.split(' - ');

        this.enderecoApolice = endereco;
        this.numeroApolice = numero;
        this.complementoApolice = complemento;
        this.bairroApolice = bairro;
        this.cepApolice = cep;
        this.cidadeApolice = cidade;
        this.estadoApolice = estado;
      }
      return;
    },
    formataEnderecoEstipulante() {
      const dados = [
        this.enderecoEstipulante,
        this.numeroEstipulante,
        this.complementoEstipulante,
        this.bairroEstipulante,
        this.cepEstipulante,
        this.cidadeEstipulante,
        this.estadoEstipulante,
      ];
      this.formCadastro.enderecoEstipulante = dados.join(' - ');
    },
    separaEnderecoEstipulante() {
      if (this.formCadastro.enderecoEstipulante) {
        const [endereco, numero, complemento, bairro, cep, cidade, estado] =
          this.formCadastro.enderecoEstipulante.split(' - ');

        this.enderecoEstipulante = endereco;
        this.numeroEstipulante = numero;
        this.complementoEstipulante = complemento;
        this.bairroEstipulante = bairro;
        this.cepEstipulante = cep;
        this.cidadeEstipulante = cidade;
        this.estadoEstipulante = estado;
      }
      return;
    },
    cpfCnpjMascara(value) {
      if (value && value.length > 14) {
        return '##.###.###/####-##';
      }
      return '###.###.###-##';
    },
    onPercentageInput(event) {
      const value = Math.max(0, Number(event));
      const accessoryLimit = value.toString().slice(0, 2);
      this.formCadastro.limiteAcessorio = accessoryLimit;
    },
  },
  created() {
    this.$validator.localize('ptBr', locale);
  },
  mounted() {
    this.buscaDadosCadastro();
    this.$i18n.locale = functions.setLocaleBasedOnCompany();
  },
  components: {
    BotaoSubmit,
    vSelect,
  },
};
</script>
<style>
#fileInput {
  display: none;
}
.img label {
  width: 100%;
  font-weight: normal;
}

.img .containericone {
  text-align: center;
  border-radius: 10px;
  padding: 10px 20px;
  -webkit-box-shadow: 0px 0px 40px -20px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 0px 0px 40px -20px rgba(0, 0, 0, 0.75);
  box-shadow: 0px 0px 40px -20px rgba(0, 0, 0, 0.75);
  width: min-content;
  margin-top: 25px;
  margin-left: 43%;
  border: 1px solid #ccc;
}

.img .icone {
  font-size: 50px;
  color: #333;
}

.input-group-color {
  display: flex !important;
  gap: 5px;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
}

.color-picker {
  max-width: 2.5rem;
  height: 2.375rem;
  border: 1px solid rgba(60, 60, 60, 0.26);
  border-radius: 4px;
}
</style>
